import React, {useCallback, useMemo} from "react";
import {cmpClassName} from "../../../common/generic-react.functions.js";
import "./fonts.styles.css.proxy.js";
import {IconContainer} from "./icon.styles.js";
function Icon({
  children,
  dataCy,
  color = "inherit",
  size = "inherit",
  disabled,
  onClick
}) {
  const _dataCy = useMemo(() => dataCy || children, [children, dataCy]);
  const iconColor = useMemo(() => {
    if (disabled) {
      return "disabled";
    }
    return color;
  }, [color, disabled]);
  const handleClick = useCallback((event) => {
    if (!disabled && onClick) {
      onClick(event);
    }
  }, [disabled, onClick]);
  return /* @__PURE__ */ React.createElement(IconContainer, {
    "data-cy": _dataCy,
    className: cmpClassName("icon"),
    color: iconColor,
    fontSize: size,
    onClick: handleClick
  }, children);
}
export default /* @__PURE__ */ React.memo(Icon);
